import { ReactNode, createContext, useContext } from "react";
import { FeatureHintEreignis, FeatureHintListItem, useFeatureHints } from "./useFeatureHints";

interface FeatureHintsValue {
  hints: FeatureHintListItem[];
  unreadCount: number;
  readOnly: boolean;
  markRead: (key: string) => void;
  markAllRead: () => void;
  /** Meldet, was gerade passiert ist (KAN-296). Gebuendelt, nie blockierend. */
  melden: (ereignisse: FeatureHintEreignis[]) => void;
  /** Die eigene Antwort auf eine Umfrage (KAN-302). Sagt, ob sie angekommen ist. */
  umfrageBeantworten: (key: string, optionen: number[]) => Promise<boolean>;
}

const FeatureHintsContext = createContext<FeatureHintsValue | null>(null);

/**
 * Haelt den Stand der Hinweise an einer Stelle, fuer alle, die ihn brauchen (KAN-251).
 *
 * Ohne das laden Seitenleiste und Anmelde-Dialog jeweils fuer sich: Der Dialog markiert
 * seinen Hinweis beim Wegklicken als gelesen, die Seitenleiste weiss davon nichts und zeigt
 * ihr Abzeichen weiter, bis die Seite neu laedt. Genau das faellt beim ersten Besuch auf.
 */
export const FeatureHintsProvider = ({ children }: { children: ReactNode }) => {
  const value = useFeatureHints();

  return <FeatureHintsContext.Provider value={value}>{children}</FeatureHintsContext.Provider>;
};

/**
 * Der gemeinsame Stand. Ausserhalb des Providers gibt es nichts zu zeigen und nichts zu
 * markieren - dann bleibt es bei einer leeren Liste, statt dass ein Bauteil abstuerzt.
 */
export const useFeatureHintsContext = (): FeatureHintsValue => {
  const value = useContext(FeatureHintsContext);
  if (value) return value;

  return {
    hints: [],
    unreadCount: 0,
    readOnly: false,
    markRead: () => undefined,
    markAllRead: () => undefined,
    melden: () => undefined,
    umfrageBeantworten: () => Promise.resolve(false),
  };
};
